import { ModuleRunsView } from './ModuleRunsView';

/** Модуль «Бюджет движения средств» (БДР): загрузка план/факт, обработки,
 *  переход к карточке. Вся механика общая — см. ModuleRunsView. */
export function BdrReport() {
  return <ModuleRunsView moduleId="bdr" />;
}
